import React from 'react';

// Request Form Modal — GPU resource request submission
export function GpuRequestForm({
  show,
  requestForm,
  setRequestForm,
  submittingRequest,
  requestError,
  onSubmit,
  onClose,
}) {
  if (!show) return null;

  const toggleFramework = (fw) => {
    setRequestForm(f => ({
      ...f, frameworks: f.frameworks.includes(fw)
        ? f.frameworks.filter(x => x !== fw)
        : [...f.frameworks, fw]
    }));
  };

  const toggleDatabase = (db) => {
    setRequestForm(f => ({
      ...f, databases: f.databases.includes(db)
        ? f.databases.filter(x => x !== db)
        : [...f.databases, db]
    }));
  };

  return (
    <div className="deploy-modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
      <div className="deploy-modal" style={{ maxWidth: 680, maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="deploy-modal-header">
          <h2>📋 GPU Resource Request</h2>
          <button className="deploy-close" onClick={onClose}>✕</button>
        </div>
        <div className="deploy-form">
          {/* Requester Info */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>Requester Information</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {[
                ['project_name', 'Project Name *', 'text', 'Domain Intelligence Solution'],
                ['officer_name', 'Officer Name', 'text', 'Sanjay Kumar'],
                ['vertical', 'Vertical / Department', 'text', 'NCTAU'],
                ['email', 'Email', 'email', 'user@example.com'],
                ['mobile', 'Mobile', 'text', '9999999999'],
              ].map(([key, label, type, ph]) => (
                <div key={key} className="deploy-field">
                  <label>{label}</label>
                  <input type={type} placeholder={ph} value={requestForm[key]||''}
                    onChange={e => setRequestForm(f => ({...f, [key]: e.target.value}))}
                    className="input" />
                </div>
              ))}
            </div>
            <div className="deploy-field" style={{ marginTop: 8 }}>
              <label>Project Description</label>
              <textarea rows={2} placeholder="Brief description of the project..."
                value={requestForm.project_description||''}
                onChange={e => setRequestForm(f => ({...f, project_description: e.target.value}))}
                className="textarea" />
            </div>
          </div>

          {/* GPU Requirements */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>GPU Requirements</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div className="deploy-field">
                <label>Usage Type</label>
                <select value={requestForm.gpu_usage_type} onChange={e => setRequestForm(f => ({...f, gpu_usage_type: e.target.value}))}
                  className="select">
                  {['training','fine-tuning','inference','processing'].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div className="deploy-field">
                <label>GPU Memory (GB)</label>
                <select value={requestForm.gpu_memory_gb} onChange={e => setRequestForm(f => ({...f, gpu_memory_gb: parseInt(e.target.value)}))}
                  className="select">
                  {[16,32,40,64,80,128,160,192].map(v => <option key={v} value={v}>{v}GB</option>)}
                </select>
              </div>
              <div className="deploy-field">
                <label>GPU Count</label>
                <select value={requestForm.gpu_count} onChange={e => setRequestForm(f => ({...f, gpu_count: parseInt(e.target.value)}))}
                  className="select">
                  {[1,2,4,8].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
            </div>
          </div>

          {/* Compute Requirements */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>Compute Requirements</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              {[
                ['vcpu_requested','vCPU (requested)','number',48],
                ['ram_requested_gb','RAM GB (requested)','number',196],
                ['storage_tb','Storage (TB)','number',4],
              ].map(([key,label,type,ph]) => (
                <div key={key} className="deploy-field">
                  <label>{label}</label>
                  <input type={type} placeholder={ph} value={requestForm[key]||''}
                    onChange={e => setRequestForm(f => ({...f, [key]: type==='number' ? parseFloat(e.target.value)||'' : e.target.value}))}
                    className="input" />
                </div>
              ))}
            </div>
          </div>

          {/* OS & Access */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>OS & Access</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div className="deploy-field">
                <label>OS Version</label>
                <select value={requestForm.os_version} onChange={e => setRequestForm(f => ({...f, os_version: e.target.value}))}
                  className="select">
                  {['Ubuntu 22.04 LTS','Ubuntu 20.04 LTS','Ubuntu 24.04 LTS'].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div className="deploy-field">
                <label>Access Type</label>
                <select value={requestForm.access_type} onChange={e => setRequestForm(f => ({...f, access_type: e.target.value}))}
                  className="select">
                  {['ssh','jupyter','both'].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div className="deploy-field">
                <label>Ports Required</label>
                <input type="text" placeholder="22,443,80" value={requestForm.ports_required||''}
                  onChange={e => setRequestForm(f => ({...f, ports_required: e.target.value}))}
                  className="input" />
              </div>
            </div>
            <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" className="check" id="internet" checked={requestForm.internet_access}
                onChange={e => setRequestForm(f => ({...f, internet_access: e.target.checked}))} />
              <label htmlFor="internet" style={{ fontSize: 13, cursor: 'pointer' }}>Internet Access Required</label>
            </div>
          </div>

          {/* Domain & Port Routing */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>
              🌐 Domain & Port Routing
            </div>
            <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 10, background: 'var(--bg)', padding: '8px 10px', borderRadius: 6 }}>
              SSH is always available via NodePort 30001-30030. Configure below if your app needs web access or extra ports.
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="deploy-field">
                <label>Subdomain (for web access via Ingress)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <input type="text" placeholder="proj1"
                    value={requestForm.subdomain||''}
                    onChange={e => setRequestForm(f => ({...f, subdomain: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g,'')}))}
                    className="input" style={{ flex: 1 }} />
                  <span style={{ fontSize: 12, color: 'var(--muted)', whiteSpace: 'nowrap' }}>.kube.sarv.com</span>
                </div>
                <div style={{ fontSize: 11, color: 'var(--muted-2)', marginTop: 3 }}>
                  Leave blank if no web access needed
                </div>
              </div>
              <div className="deploy-field">
                <label>App Port (what your app listens on)</label>
                <input type="number" placeholder="e.g. 3000, 8501, 8080"
                  value={requestForm.app_port||''}
                  onChange={e => setRequestForm(f => ({...f, app_port: e.target.value}))}
                  className="input" />
                <div style={{ fontSize: 11, color: 'var(--muted-2)', marginTop: 3 }}>
                  Required if subdomain is set
                </div>
              </div>
            </div>
            <div className="deploy-field" style={{ marginTop: 10 }}>
              <label>Extra Ports to expose via NodePort (internet accessible)</label>
              <input type="text" placeholder="e.g. 5000,8501,3001"
                value={requestForm.extra_ports||''}
                onChange={e => setRequestForm(f => ({...f, extra_ports: e.target.value}))}
                className="input" />
              <div style={{ fontSize: 11, color: 'var(--muted-2)', marginTop: 3 }}>
                Each port gets a NodePort in range 30031-30100. Leave blank if not needed.
              </div>
            </div>
            {requestForm.subdomain && requestForm.app_port && (
              <div style={{ marginTop: 8, padding: '8px 12px', background: 'var(--brand-soft)', borderRadius: 6, fontSize: 12, color: 'var(--brand)' }}>
                ✓ Web URL: <strong>https://{requestForm.subdomain}.kube.sarv.com</strong> → port {requestForm.app_port}
              </div>
            )}
          </div>

          {/* Frameworks */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>Frameworks & Databases</div>
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>Frameworks</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {['python','nodejs','pytorch','tensorflow','java','php'].map(fw => (
                  <button key={fw} type="button"
                    className={`chip ${requestForm.frameworks.includes(fw) ? '' : 'grey'}`}
                    onClick={() => toggleFramework(fw)}>
                    {fw}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>Databases</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {['redis','postgres','mysql','mongodb'].map(db => (
                  <button key={db} type="button"
                    className={`chip ${requestForm.databases.includes(db) ? 'accent' : 'grey'}`}
                    onClick={() => toggleDatabase(db)}>
                    {db}
                  </button>
                ))}
              </div>
            </div>
            <div className="deploy-field" style={{ marginTop: 10 }}>
              <label>Additional Packages (pip/apt)</label>
              <textarea rows={2} placeholder="transformers, accelerate, fastapi, ..."
                value={requestForm.extra_packages||''}
                onChange={e => setRequestForm(f => ({...f, extra_packages: e.target.value}))}
                className="textarea" />
            </div>
          </div>

          {/* LLM Model Section */}
          <div className="deploy-section">
            <div style={{ fontWeight: 600, marginBottom: 10, color: 'var(--ink-2)', fontSize: 13 }}>
              🤖 LLM Model (deployed to /opt/dlami/nvme)
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div className="deploy-field" style={{ gridColumn: '1 / 3' }}>
                <label>LLM Model (HuggingFace ID)</label>
                <select value={requestForm.llm_model||''}
                  onChange={e => setRequestForm(f => ({...f, llm_model: e.target.value}))}
                  className="select">
                  <option value="">— No LLM model —</option>
                  <optgroup label="Gemma 4 (Google) — MoE Architecture">
                    <option value="google/gemma-4-26B-A4B-it">Gemma 4 26B MoE · 4B active (I4C requirement) — 52GB disk, ~8GB VRAM</option>
                    <option value="google/gemma-4-31B-it">Gemma 4 31B — 62GB disk, ~16GB VRAM</option>
                    <option value="google/gemma-4-E4B-it">Gemma 4 8B dense — 16GB disk, ~8GB VRAM</option>
                  </optgroup>
                  <optgroup label="Gemma 3 (Google)">
                    <option value="google/gemma-3-27b-it">Gemma 3 27B</option>
                    <option value="google/gemma-3-12b-it">Gemma 3 12B</option>
                  </optgroup>
                  <optgroup label="LLaMA 3 (Meta)">
                    <option value="meta-llama/Llama-3.1-8B-Instruct">LLaMA 3.1 8B</option>
                    <option value="meta-llama/Llama-3.1-70B-Instruct">LLaMA 3.1 70B</option>
                    <option value="meta-llama/Llama-3.3-70B-Instruct">LLaMA 3.3 70B</option>
                    <option value="meta-llama/Llama-3.1-405B-Instruct">LLaMA 3.1 405B</option>
                  </optgroup>
                  <optgroup label="Other">
                    <option value="mistralai/Mistral-7B-Instruct-v0.3">Mistral 7B</option>
                    <option value="custom">Custom (enter below)</option>
                  </optgroup>
                </select>
              </div>
              <div className="deploy-field">
                <label>Quantization</label>
                <select value={requestForm.llm_quantization||'int8'}
                  onChange={e => setRequestForm(f => ({...f, llm_quantization: e.target.value}))}
                  className="select">
                  <option value="none">None (FP32/BF16)</option>
                  <option value="int8">INT8 (~50% VRAM)</option>
                  <option value="int4">INT4 (~25% VRAM)</option>
                </select>
              </div>
              {requestForm.llm_model === 'custom' && (
                <div className="deploy-field" style={{ gridColumn: '1 / 4' }}>
                  <label>Custom Model ID</label>
                  <input type="text" placeholder="org/model-name"
                    onChange={e => setRequestForm(f => ({...f, llm_model: e.target.value}))}
                    className="input" />
                </div>
              )}
            </div>
            <div style={{ marginTop: 8, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="deploy-field">
                <label>NVMe Local Storage (TB) at /opt/dlami/nvme</label>
                <input type="number" step="0.5" min="0" placeholder="2"
                  value={requestForm.nvme_storage_tb||''}
                  onChange={e => setRequestForm(f => ({...f, nvme_storage_tb: parseFloat(e.target.value)||0}))}
                  className="input" />
                <div style={{ fontSize: 11, color: 'var(--muted-2)', marginTop: 3 }}>
                  Persistent NVMe at /opt/dlami/nvme — survives container restart
                </div>
              </div>
            </div>
          </div>

          {requestError && <div className="deploy-error">{requestError}</div>}
          <div className="deploy-actions">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={onSubmit} disabled={submittingRequest}>
              {submittingRequest ? 'Submitting...' : '📋 Submit Request'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
